import { render, staticRenderFns } from "./ReportPrintHeader.vue?vue&type=template&id=54876c0e&"
import script from "./ReportPrintHeader.vue?vue&type=script&lang=js&"
export * from "./ReportPrintHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports